<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="acknowledgement"><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/>
<p style="text-indent:0px;">Other books by the same author:</p><br/>
<p style="text-indent:0px;">The Klondikers</p>
<p style="text-indent:0px;">K2, The Savage Mountain</p>
<p style="text-indent:0px;">Overlanding the Silk Road</p>
<p style="text-indent:0px;">Crossing Russia on the Trans-Siberian</p>
<p style="text-indent:0px;">Yellow School Bus</p>
<p style="text-indent:0px;">Across the Caspian</p>
<p style="text-indent:0px;">Condors over Chile</p>
<p style="text-indent:0px;">Gold, Ivory and Slaves</p>
<p style="text-indent:0px;">Carnival</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0001.vue?d7e8c5f4